import React from 'react';
import PageHeaderText from 'components/base/page-header-text';
import { Button } from '@cokitchen/cokitchen-components';
import useExcessReturnContext from 'contexts/excess-returns.context/context';

const KitchenExcessReturnsDetails = () => {
  const { excessReturnToUpdate } = useExcessReturnContext();

  const handleConfirmClick = () => {
    console.log('handle click ');
  };

  return (
    <div>
      <PageHeaderText
        title={`Return #${excessReturnToUpdate.id.substring(0, 5)} `}
        description='Manage excess returns by kitchem'
      />
      <div className='border-4 border-[#F7F7F8] rounded py-[24px]  md:max-w-[670px]'>
        <div className='flex justify-between px-[28px]'>
          <div className=' pb-5'>
            <p className='font-semibold text-[24px] '>Update excess items</p>
            <p className='text-[#6F7376] text-sm'>Certain items were returned, ensure to cofirm</p>
          </div>
        </div>
        {excessReturnToUpdate.items.map((item, index) => (
          <div
            className='flex justify-between py-[24px] px-[28px] border-b border-b-[#F7F7F8]'
            key={index}>
            <div>
              <p className='text-[16px] font-semibold pb-[4px] '>{item.ingredient.name}</p>
              <p className='font-medium '>{item.ingredient.unit_type}</p>
            </div>
          </div>
        ))}
        <div>
          <hr className='border-t-4 border-[#F7F7F8]' />
          <div className='flex gap-6 items-center justify-end mt-6 mx-[28px] ml-auto'>
            <Button variant='link' color='gray' small>
              Cancel
            </Button>
            <Button
              variant='block'
              color='primary'
              small
              className='w-[153px] h-[43px]'
              onClick={handleConfirmClick}>
              Confirm
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KitchenExcessReturnsDetails;
